import {UrlProviderInterface} from 'modules/spravochnik/dt-front-page-generator/src/Entity/UrlProviderInterface';
import { Router } from 'vue-router';

export class UrlService {
    public constructor(
        private router: Router,
        private entity: UrlProviderInterface,
        private pageNumber: number = 1,
    ) {
    }

    public updateEntity(): UrlService {
        this.update(this.entity);

        return this;
    }

    public changePageNumber(pageNumber: number): void {
        this.router.replace({query: {page: pageNumber === 1 ? undefined : pageNumber}});
    }

    private update(entity: UrlProviderInterface): void {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        for (const [identity, value] of urlParams.entries()) {
            if (typeof identity === 'string') {
                const filter = this.entity.filters.findFilterByIdentity(identity);
                if (filter) {
                    filter.value.setGetParam(value);
                }
            }

            if (identity === '_sort' && entity) {
                for (const sort of this.entity.allowedSortModes) {
                    if (sort.id === value) {
                        entity.sortMode = sort;
                        break;
                    }
                }
            }
        }
    }

    apply(): UrlService {
        const url = new Map<string, string>();
        for (const filter of this.entity.filters) {
            if (filter.hasValue()) {
                url.set(filter.id, filter.value.toGetParam());
            }
        }

        const sort = this.entity.sortMode;
        if (sort && !sort.default) {
            url.set('_sort', sort.id);
        }

        if (this.pageNumber || this.pageNumber !== 1) {
            url.set('page', String(this.pageNumber));
        }

        this.setGetParams(url);

        return this;
    }

    private setGetParams(params: Map<string, string>): void {
        this.router.replace({query: Object.fromEntries(params)});
    }
}
